import { render } from "./TermsAndConditions.vue?vue&type=template&id=46a969a5&scoped=true&ts=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=46a969a5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a969a5"]])

export default __exports__